// Include external
// js error logger
Raven.config("https://0a8bf06a398c40f88f4104cb6e574e35@sentry.io/1190736", {
    whitelistUrls: [
        /\/assets\//
    ]
}).install();